import { Currency } from '@nemuru-eng/js-api-client';

import { FinancingLiveSummaryData } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/types/FinancingLiveSummaryData';
import { createEditVehicleLiveSummaryFormatters } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/utils/editVehicleLiveSummaryFormatters';
import { CustomAlert } from '@/components/shared/components/CustomAlert';
import { Text } from '@/components/shared/components/Text';

interface FinancingReselectionWarningProps {
  initialFinancing: FinancingLiveSummaryData;
  currency: Currency;
}

export const FinancingReselectionWarning = ({ initialFinancing, currency }: FinancingReselectionWarningProps) => {
  const { formatMoneyAmount } = createEditVehicleLiveSummaryFormatters();
  const { instalmentAmount, term } = initialFinancing;
  const hasCurrentConditions = instalmentAmount !== null && term !== null;

  return (
    <CustomAlert
      style={{
        paddingBlock: '12px',
      }}
      severity="warning"
      title="FINANCING_RESELECTION_REQUIRED"
      description={
        hasCurrentConditions ? (
          <Text
            tId="FINANCING_RESELECTION_REQUIRED_DESCRIPTION"
            dynamicDataTexts={[formatMoneyAmount(instalmentAmount, currency), String(term)]}
          />
        ) : (
          'VEHICLE_AMOUNT_REQUIRES_FINANCING_RESELECTION_DESCRIPTION'
        )
      }
    />
  );
};
